import React, { useCallback, useMemo, useState } from "react";
import axios from "axios";
import { Link, Redirect, useHistory } from "react-router-dom";
import {
  FaBell,
  FaChalkboardTeacher,
  FaGlobe,
  FaHome,
  FaPaperPlane,
  FaUserGraduate,
  FaUserTie,
} from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import MyLoader from "../Spinner/MyLoader";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import BackButton from "../ChildComponent/BackButton";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import MdlSelectMultipleClass from "../dialog/MdlSelectMultipleClass";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import "../css/Admin_css/AddNotice.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const PLACEHOLDER_IMG =
  "https://www.galaxyskills.org/wp-content/uploads/2019/02/dummy-350x350.png";

// Created By Cursor
function classOf(item) {
  return Array.isArray(item?.class) ? item.class[0] || {} : {};
}

// Created By Cursor
export default function SendNotification() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;

  const [loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [isOpenSelectClass, setIsOpenSelectClass] = useState(false);
  const [showSelectedStudent, setShowSelectedStudent] = useState(false);
  const [showSelectedClass, setShowSelectedClass] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mSelectedClass, setMSelectedClass] = useState([]);

  const [isCheckedChkGlobal, setIsCheckedChkGlobal] = useState(false);
  const [isCheckedChkStudent, setIsCheckedChkStudent] = useState(false);
  const [isCheckedChkClass, setIsCheckedChkClass] = useState(false);
  const [isCheckedChkStaff, setIsCheckedChkStaff] = useState(false);

  const [flagAllStudent, setFlagAllStudent] = useState(true);
  const [flagSelectStudent, setFlagSelectStudent] = useState(false);
  const [flagAllClass, setFlagAllClass] = useState(true);
  const [flagSelectClass, setFlagSelectClass] = useState(false);

  const [orderedBy, setOrderedBy] = useState("Principal");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const goInbox = useCallback(() => {
    history.push("/AdminMain/Notification/1");
  }, [history]);

  const onChangeChkGlobal = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(true);
      setIsCheckedChkStudent(false);
      setIsCheckedChkClass(false);
      setIsCheckedChkStaff(false);
    } else {
      setIsCheckedChkGlobal(false);
    }
  };

  const onChangeChkStudent = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkStudent(true);
      setFlagAllStudent(true);
      setFlagSelectStudent(false);
    } else {
      setIsCheckedChkStudent(false);
    }
  };

  const onChangeChkClass = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkClass(true);
      setFlagAllClass(true);
      setFlagSelectClass(false);
    } else {
      setIsCheckedChkClass(false);
    }
  };

  const onChangeChkStaff = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setIsCheckedChkGlobal(false);
      setIsCheckedChkStaff(true);
    } else {
      setIsCheckedChkStaff(false);
    }
  };

  const toAllStudent = () => {
    setFlagAllStudent(true);
    setFlagSelectStudent(false);
    setFlagAllClass(false);
    setFlagSelectClass(false);
    setIsCheckedChkClass(false);
  };

  const selectStudent = () => {
    setFlagAllStudent(false);
    setFlagSelectStudent(true);
    setFlagAllClass(false);
    setIsOpenSelectStudent(true);
  };

  const toAllClass = () => {
    setFlagAllClass(true);
    setFlagSelectClass(false);
    setFlagAllStudent(false);
    setFlagSelectStudent(false);
    setIsCheckedChkStudent(false);
  };

  const selectClass = () => {
    setFlagAllClass(false);
    setFlagSelectClass(true);
    setFlagAllStudent(false);
    setIsOpenSelectClass(true);
  };

  const handleSelectedStudent = (selected) => {
    const list = Array.isArray(selected) ? selected : [];
    setIsOpenSelectStudent(false);
    setShowSelectedStudent(true);
    setMSelectedStudent(list);
  };

  const handleSelectedClass = () => {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem("SelectedMultipleClass")) || [];
    } catch (err) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    setIsOpenSelectClass(false);
    setShowSelectedClass(true);
    setMSelectedClass(list);
  };

  const prepareRecipient = useCallback(() => {
    const list = [];
    if (isCheckedChkGlobal) {
      list.push("GLOBAL");
      return list;
    }
    if (isCheckedChkStudent) {
      if (flagAllStudent) {
        list.push("ALL_STUDENT");
      } else if (flagSelectStudent) {
        mSelectedStudent.forEach((row) => {
          if (row?.student_enrollment_no) {
            list.push(row.student_enrollment_no);
          }
        });
      }
    }
    if (isCheckedChkClass) {
      if (flagAllClass) {
        list.push("ALL_CLASS");
      } else if (flagSelectClass) {
        mSelectedClass.forEach((row) => {
          const classId = row?.class_id;
          if (!classId) return;
          const sectionId =
            row?.section_id != null && String(row.section_id) !== ""
              ? row.section_id
              : "No";
          list.push(`${classId}#${sectionId}`);
        });
      }
    }
    if (isCheckedChkStaff) {
      list.push("ALL_STAFF");
    }
    return list;
  }, [
    isCheckedChkGlobal,
    isCheckedChkStudent,
    isCheckedChkClass,
    isCheckedChkStaff,
    flagAllStudent,
    flagSelectStudent,
    flagAllClass,
    flagSelectClass,
    mSelectedStudent,
    mSelectedClass,
  ]);

  const isValidInput = () => {
    if (!String(title || "").trim()) {
      myToast.notify_warning("Enter message title.");
      return false;
    }
    if (!String(message || "").trim()) {
      myToast.notify_warning("Enter message.");
      return false;
    }
    if (!String(orderedBy || "").trim()) {
      myToast.notify_warning("Enter ordered by.");
      return false;
    }
    if (
      !isCheckedChkGlobal &&
      !isCheckedChkStudent &&
      !isCheckedChkClass &&
      !isCheckedChkStaff
    ) {
      myToast.notify_warning("Please select a recipient.");
      return false;
    }
    if (
      isCheckedChkStudent &&
      flagSelectStudent &&
      mSelectedStudent.length === 0
    ) {
      myToast.notify_warning("Please select at least one student.");
      return false;
    }
    if (isCheckedChkClass && flagSelectClass && mSelectedClass.length === 0) {
      myToast.notify_warning("Please select at least one class.");
      return false;
    }
    return true;
  };

  const submitNotification = async () => {
    if (!isValidInput()) return;
    const recipients = prepareRecipient();
    if (!recipients.length) {
      myToast.notify_warning("Please select a recipient.");
      return;
    }
    const schoolCode = SessionManager.getSchoolCode();
    const staffId = SessionManager.getStaffDetails()?.staff_id;
    if (!schoolCode || !staffId) {
      myToast.notify_warning("Missing school or staff details.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios
        .get(`${API_BASE()}sendNotificationToStudents.php`, {
          params: {
            title: title.trim(),
            message: message.trim(),
            recipient: JSON.stringify(recipients),
            staff_id: staffId,
            department: orderedBy.trim(),
            school_code: schoolCode,
          },
        })
        .then((res) => res.data);

      if (response?.api_status === "OK") {
        myToast.notify_success("Notification sent.");
        goInbox();
      } else {
        myToast.notify_warning(
          response?.api_remark || "Could not send notification."
        );
      }
    } catch (error) {
      console.error(error);
      myToast.notify_warning("Failed to send notification.");
    } finally {
      setLoading(false);
    }
  };

  const recipientSummary = useMemo(() => {
    const parts = [];
    if (isCheckedChkGlobal) parts.push("Global");
    if (isCheckedChkStudent) {
      parts.push(
        flagAllStudent
          ? "All students"
          : `${mSelectedStudent.length} student${
              mSelectedStudent.length === 1 ? "" : "s"
            }`
      );
    }
    if (isCheckedChkClass) {
      parts.push(
        flagAllClass
          ? "All classes"
          : `${mSelectedClass.length} class${
              mSelectedClass.length === 1 ? "" : "es"
            }`
      );
    }
    if (isCheckedChkStaff) parts.push("All staff");
    return parts.length ? parts.join(" · ") : "No recipient selected";
  }, [
    isCheckedChkGlobal,
    isCheckedChkStudent,
    isCheckedChkClass,
    isCheckedChkStaff,
    flagAllStudent,
    flagAllClass,
    mSelectedStudent.length,
    mSelectedClass.length,
  ]);

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page an-page"
      style={{ fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <button
                type="button"
                className="an-crumb-link"
                onClick={goInbox}
              >
                Notifications
              </button>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Send Notification</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell an-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaPaperPlane />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Send Notification</h1>
              <p className="sm-hero__sub">{recipientSummary}</p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <button
              type="button"
              className="an-hero-btn"
              onClick={goInbox}
              disabled={loading}
            >
              <FaBell aria-hidden /> Inbox
            </button>
            <button
              type="button"
              className="an-hero-btn an-hero-btn--solid"
              onClick={submitNotification}
              disabled={loading}
            >
              <FaPaperPlane aria-hidden />
              {loading ? "Sending…" : "Send"}
            </button>
          </div>
        </header>

        <div className="an-body">
          {loading ? (
            <div className="an-loading">
              <MyLoader />
            </div>
          ) : null}

          <div className="an-summary">
            <div className="an-summary__icon" aria-hidden>
              <FaBell />
            </div>
            <div className="an-summary__text">
              <strong>Audience</strong>
              <span>{recipientSummary}</span>
            </div>
          </div>

          <section className="an-section an-section--details">
            <h2 className="an-section__title">
              <span className="an-section__step" aria-hidden>
                1
              </span>
              <span className="an-section__title-icon" aria-hidden>
                <FaBell />
              </span>
              Message
            </h2>
            <div className="an-section__body">
              <div className="an-grid an-grid--2">
                <div className="an-field">
                  <label className="an-field__label" htmlFor="input_message_title">
                    Title *
                  </label>
                  <input
                    type="text"
                    id="input_message_title"
                    className="an-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    disabled={loading}
                    placeholder="Notification title"
                  />
                </div>
                <div className="an-field">
                  <label className="an-field__label" htmlFor="input_ordered_by">
                    Ordered by *
                  </label>
                  <input
                    type="text"
                    id="input_ordered_by"
                    className="an-input"
                    value={orderedBy}
                    onChange={(e) => setOrderedBy(e.target.value)}
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="an-field an-field--wide an-field--notice">
                <div className="an-field__head">
                  <label className="an-field__label" htmlFor="input_notice">
                    Message *
                  </label>
                  <span className="an-field__count">
                    {String(message || "").trim().length} chars
                  </span>
                </div>
                <textarea
                  id="input_notice"
                  className="an-textarea"
                  rows={6}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  disabled={loading}
                  placeholder="Write the notification message…"
                />
              </div>
            </div>
          </section>

          <section className="an-section an-section--recipients">
            <h2 className="an-section__title">
              <span className="an-section__step" aria-hidden>
                2
              </span>
              <span className="an-section__title-icon" aria-hidden>
                <FaGlobe />
              </span>
              Recipients
            </h2>
            <div className="an-section__body an-recipients">
              <div
                className={`an-recip an-recip--global${
                  isCheckedChkGlobal ? " is-on" : ""
                }`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    checked={isCheckedChkGlobal}
                    onChange={onChangeChkGlobal}
                    disabled={loading}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaGlobe />
                  </span>
                  <span className="an-check__text">
                    <strong>Global school</strong>
                    <small>All students and all staff</small>
                  </span>
                </label>
                {isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <p className="an-panel__hint">
                      Notification will be sent to everyone in the school.
                    </p>
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--student${
                  isCheckedChkStudent && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    checked={isCheckedChkStudent}
                    onChange={onChangeChkStudent}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaUserGraduate />
                  </span>
                  <span className="an-check__text">
                    <strong>Students</strong>
                    <small>All students or selected students</small>
                  </span>
                </label>
                {isCheckedChkStudent && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <div className="an-option-row">
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagAllStudent ? " is-active" : ""
                        }`}
                        onClick={toAllStudent}
                        disabled={loading}
                      >
                        To all students
                      </button>
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagSelectStudent ? " is-active" : ""
                        }`}
                        onClick={selectStudent}
                        disabled={loading}
                      >
                        Select students
                      </button>
                    </div>
                    {flagAllStudent ? (
                      <p className="an-panel__hint">All students selected.</p>
                    ) : null}
                    {showSelectedStudent && flagSelectStudent ? (
                      <div className="an-pick-list">
                        {mSelectedStudent.length === 0 ? (
                          <p className="an-panel__hint">No students selected.</p>
                        ) : (
                          mSelectedStudent.map((item, index) => {
                            const cls = classOf(item);
                            return (
                              <div
                                className="an-pick-item"
                                key={item.student_enrollment_no || index}
                              >
                                <img
                                  className="an-pick-item__avatar"
                                  src={item.student_img_path || PLACEHOLDER_IMG}
                                  alt=""
                                />
                                <div className="an-pick-item__main">
                                  <strong>{item.stu_name || "—"}</strong>
                                  <span>
                                    {item.student_enrollment_no || "—"}
                                    {cls.class_name
                                      ? ` · ${cls.class_name}${
                                          cls.section_name
                                            ? `:${cls.section_name}`
                                            : ""
                                        }`
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--class${
                  isCheckedChkClass && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    checked={isCheckedChkClass}
                    onChange={onChangeChkClass}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaChalkboardTeacher />
                  </span>
                  <span className="an-check__text">
                    <strong>Classes</strong>
                    <small>All classes or selected classes</small>
                  </span>
                </label>
                {isCheckedChkClass && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <div className="an-option-row">
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagAllClass ? " is-active" : ""
                        }`}
                        onClick={toAllClass}
                        disabled={loading}
                      >
                        To all classes
                      </button>
                      <button
                        type="button"
                        className={`an-option-btn${
                          flagSelectClass ? " is-active" : ""
                        }`}
                        onClick={selectClass}
                        disabled={loading}
                      >
                        Select classes
                      </button>
                    </div>
                    {flagAllClass ? (
                      <p className="an-panel__hint">All classes selected.</p>
                    ) : null}
                    {showSelectedClass && flagSelectClass ? (
                      <div className="an-pick-list">
                        {mSelectedClass.length === 0 ? (
                          <p className="an-panel__hint">No classes selected.</p>
                        ) : (
                          mSelectedClass.map((item, index) => (
                            <div
                              className="an-pick-item"
                              key={`${item.class_id}-${item.section_id}-${index}`}
                            >
                              <div className="an-pick-item__badge" aria-hidden>
                                <FaChalkboardTeacher />
                              </div>
                              <div className="an-pick-item__main">
                                <strong>
                                  {item.section === "No" ||
                                  item.section_id === "No"
                                    ? `Class: ${item.class_name || "—"}`
                                    : `${item.class_name || "—"}: ${
                                        item.section_name || "—"
                                      }`}
                                </strong>
                                <span>
                                  {[item.board_name, item.medium_name]
                                    .filter(Boolean)
                                    .join(" · ") || "—"}
                                </span>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div
                className={`an-recip an-recip--staff${
                  isCheckedChkStaff && !isCheckedChkGlobal ? " is-on" : ""
                }${isCheckedChkGlobal ? " is-disabled" : ""}`}
              >
                <label className="an-check">
                  <input
                    type="checkbox"
                    checked={isCheckedChkStaff}
                    onChange={onChangeChkStaff}
                    disabled={loading || isCheckedChkGlobal}
                  />
                  <span className="an-check__icon" aria-hidden>
                    <FaUserTie />
                  </span>
                  <span className="an-check__text">
                    <strong>Staff</strong>
                    <small>All staff members</small>
                  </span>
                </label>
                {isCheckedChkStaff && !isCheckedChkGlobal ? (
                  <div className="an-panel">
                    <p className="an-panel__hint">All staff selected.</p>
                  </div>
                ) : null}
              </div>
            </div>
          </section>

          <div className="an-actions">
            <Link
              to="/AdminMain/Notification/1"
              className="an-btn an-btn--secondary"
            >
              Cancel
            </Link>
            <button
              type="button"
              className="an-btn an-btn--primary"
              onClick={submitNotification}
              disabled={loading}
            >
              <FaPaperPlane aria-hidden />
              {loading ? "Sending…" : "Send notification"}
            </button>
          </div>
        </div>
      </div>

      {isOpenSelectStudent ? (
        <MdlSelectMultipleStudent
          actionClose={() => setIsOpenSelectStudent(false)}
          actionHandleSelected={handleSelectedStudent}
        />
      ) : null}

      {isOpenSelectClass ? (
        <MdlSelectMultipleClass
          action={() => setIsOpenSelectClass(false)}
          action2={handleSelectedClass}
        />
      ) : null}
    </div>
  );
}
